'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _clickOutside = require('click-outside');

var _clickOutside2 = _interopRequireDefault(_clickOutside);

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _estoreComponents = require('@viskan/estore-components');

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

var _togglerPresentation = require('../../utils/toggler-presentation');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var afterMount = function afterMount(_ref, element) {
	var props = _ref.props;

	element.addEventListener('mousedown', function () {
		element.dataset.isClicked = true;
	}, true);

	var upListener = function upListener() {
		if (!document.contains(element)) {
			return document.removeEventListener('click', upListener);
		}

		delete element.dataset.isClicked;
	};

	document.addEventListener('click', upListener);
}; /** @jsx dom */


var afterRender = function afterRender(_ref2, element) {
	var props = _ref2.props;
	var cmsHidden = props.cmsHidden,
	    cmsOpenLeft = props.cmsOpenLeft,
	    isOpen = props.isOpen,
	    close = props.close;


	if (cmsHidden || !cmsOpenLeft) {
		var createListener = function createListener() {
			var unbindListener = (0, _clickOutside2.default)(element, function () {
				if (element.dataset.isClicked) {
					return;
				}

				if (!document.body.contains(element)) {
					return unbindListener();
				}

				if (isOpen) {
					close();
				}
			});
		};

		requestAnimationFrame(createListener);
	}
};

var render = function render(_ref3) {
	var props = _ref3.props;
	var id = props.id,
	    isOpen = props.isOpen,
	    openOnHover = props.openOnHover,
	    styleClasses = props.styleClasses,
	    toggle = props.toggle;

	var children = props.children.length > 0 ? props.children : (0, _magicVirtualElement2.default)('div', { 'data-id': id, 'class': 'CMS-Dropdown-placeholder CMS-Component' });
	var presentationOpen = (0, _togglerPresentation.getPresentation)('Open', props);
	var presentationClosed = (0, _togglerPresentation.getPresentation)('Closed', props);

	var classes = {
		'CMS-DropdownMenu': true,
		'is-open': isOpen
	};

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['CMS-Dropdown-wrapper', styleClasses.Wrapper], 'data-style-attr': 'Wrapper' },
		(0, _magicVirtualElement2.default)(
			_estoreComponents.Dropdown,
			{ 'class': ['CMS-Dropdown', props.class], styleClasses: styleClasses, onMouseOver: openOnHover && toggle, onMouseOut: openOnHover && toggle },
			(0, _magicVirtualElement2.default)(
				'span',
				{ 'class': ['CMS-Dropdown-icon', styleClasses.Icon], 'data-style-attr': 'Icon', onClick: toggle },
				isOpen ? presentationOpen : presentationClosed
			),
			(0, _magicVirtualElement2.default)(
				_estoreComponents.DropdownMenu,
				{ 'class': classes, styleClasses: styleClasses, alignRight: true },
				isOpen && children
			)
		)
	), props);
};

exports.default = { afterMount: afterMount, afterRender: afterRender, render: render };